import { useMemo } from 'react';
import { hasScope, SCOPES } from '../utils/auth';
import { useContractData } from './useFetchContractData';
export function useContractPermissions({
  objectId,
  objectTypeId,
  skip
}) {
  const {
    data
  } = useContractData({
    objectId,
    objectTypeId
  }, {
    skip
  });
  return useMemo(() => {
    const {
      userPermissions
    } = data !== null && data !== void 0 ? data : {};
    const isJitaUser = () => hasScope(SCOPES.jitaUser);
    const hasDelete = () => Boolean(hasScope(SCOPES.contract.delete) && (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.currentUserCanDelete));
    const hasRead = () => Boolean(hasScope(SCOPES.contract.read) && (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.currentUserCanView));
    const hasWrite = () => Boolean(hasScope(SCOPES.contract.write) && (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.currentUserCanEdit));
    const hasAccess = () => Boolean(hasScope(SCOPES.contract.access) && (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.currentUserCanView));
    const canEditAssociation = (defaultEditAssociation = false) => defaultEditAssociation && hasScope(SCOPES.writeCRMAssociations) && hasWrite();
    return {
      isJitaUser,
      hasDelete,
      hasRead,
      hasWrite,
      hasAccess,
      canEditAssociation
    };
  }, [data]);
}